import React, { useEffect, useState } from 'react';
import { axios } from '../../libs/axios';

const COPY_KEYS = [
  'expertPrefix',
  'expertBothTopics',
  'expertAllThreeTopics',
  'experienceYears',
  'priceHourlyFrom',
  'speedBadge',
  'newHugoBadge',
  'coverageTwoTopics',
  'coverageThreeTopics',
  'completedProjects',
  'responseTimePrefixBusiness',
  'curationClosing',
  'readMore',
];

export function MatchV2CopiesSection({ locale = 'et' }) {
  const [strings, setStrings] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await axios.get('/match/display-strings', { params: { locale } });
        if (!cancelled) {
          setStrings(res.strings || {});
        }
      } catch {
        if (!cancelled) setStrings({});
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [locale]);

  return (
    <>
      <div className="section">Copies (read-only)</div>
      <p className="small text-muted mb-2">
        Client-facing badge and card strings for locale <strong>{locale}</strong>. Not editable in the builder yet.
      </p>
      {loading && <p className="small text-muted">Loading…</p>}
      {!loading && (
        <ul className="small mb-0" style={{ listStyle: 'none', paddingLeft: 0 }}>
          {COPY_KEYS.map((key) => (
            <li key={key} className="mb-1">
              <code>{key}</code>: {strings?.[key] || '—'}
            </li>
          ))}
        </ul>
      )}
    </>
  );
}
